/**
 * Error constructed from our API error response body
 */
export class ApiError extends Error {
  constructor(public readonly message: string, public readonly status?: number, public readonly code?: string) {
    super(message);
  }
}
